import SimplePage from "@/components/simple-page/index";
import TicketPackage from "@/components/ticket-package/index";
import PAGE_HEADER from "./page-header.yaml";
import PAGE_AFTER_FORM from "./page-after-form.yaml";
import TICKETS from "@/data/puppy-weekend/tickets.yaml";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  components: { SimplePage, TicketPackage },
  mixins: [dynamicLocalization],
  data() {
    return {
      pages: [
        {
          sections: PAGE_HEADER.sections,
          title: PAGE_HEADER.title,
          heroImage: PAGE_HEADER.heroImage,
        },
        {
          sections: PAGE_AFTER_FORM.sections,
          title: PAGE_AFTER_FORM.title,
          heroImage: PAGE_AFTER_FORM.heroImage,
        },
      ],
      ticketCategories: TICKETS.ticket_categories,
      priceCategories: TICKETS.price_categories,
    };
  },
};
